import createHashHistory from 'history/lib/createHashHistory';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/combined';

export const history = createHashHistory({ queryKey: false, });

const finalCreateStore = compose(
  // middleware you want to use in development:
  applyMiddleware(thunk),
  // required! Enable Redux DevTools with the monitors you chose
  // devTools.instrument(),
  window.devToolsExtension ? window.devToolsExtension() : f => f
)(createStore);

function getDebugSessionKey() {
  // you can write custom logic here!
  // by default we try to read the key from ?debug_session=<key> in the address bar
  const matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
  return (matches && matches.length > 0) ? matches[1] : null;
}

export default function configureStore(initialState) {
  const store = finalCreateStore(rootReducer, initialState);

  return store;
}
